import CallCentersTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    CallCentersTable
  },
  data() {
    return {
      callCenters: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('callCenters.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.callCenters.index'), route: {}}
    ])
  },
  methods: {
    loadCallCenters(queryOptions = {}) {
      API.callCenters.index(queryOptions).then(({data, meta}) => {
        this.callCenters = data
        this.meta = meta
      })
    }
  }
})
